module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new-shop-page"
    }
  }, [(_vm.bannerList.length > 0) ? _c('banner', {
    attrs: {
      "data": _vm.bannerList
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [(_vm.jpsdGoodsAdvList.length > 0) ? _c('boutique', {
    attrs: {
      "data": _vm.jpsdGoodsAdvList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storePinPaiList.length > 0) ? _c('store-list', {
    attrs: {
      "data": _vm.storePinPaiList
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5818cb7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/enterprise-brand-store/index.vue
// module id = 1608
// module chunks = 1